export default (role, action, resource, permissions, allowedRoles = null) => {

  if (allowedRoles) {
    return allowedRoles.indexOf(role) !== -1 ? true : false;
  }

  if (role === 'owner' || resource === '*') return true;
  const found = permissions.find((permission) => permission[2] === resource && permission[4] === 'allow');
  // const found = permissions.find((permission) => permission[1] === resource);
  if (found) {
    const actions = found[3].split('|');
    if (actions.length === 1) return actions[0] === `^${action}$`;
    else if (actions.length > 0) {
      return actions.indexOf(`(^${action}$)`) !== -1;
    }
  }
  return false;
}